// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CustomSummaryCard — grouped KPI card (title + numbers split by dividers) */

.csum-row {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

/*
 * A card alone on its line (e.g. "Messages" after the row wraps) must not stretch across the page:
 * at most half the row, like col-6 — unless its numbers need more room (--csum-cols × ~110px).
 */
.csum-row > .csum-card {
  max-width: max(calc(50% - 7px), calc(var(--csum-cols, 2) * 110px + 22px));
}

.csum-card {
  --csum-accent: var(--cui-primary);
  --csum-tint: var(--cui-primary-soft);
  position: relative;
  box-sizing: border-box; /* padding counts inside the flex width, so rows don't wrap early */
  /* never squeezed below ~84px per number: the whole card wraps to the next line instead */
  min-width: calc(var(--csum-cols, 2) * 84px + 22px);
  display: flex;
  flex-direction: column;
  padding: 16px 10px 14px;
  border-radius: 16px;
  border: 1px solid var(--cui-border-soft, #e6e9f0);
  background: linear-gradient(180deg, var(--csum-tint) 0%, #ffffff 58%);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 20px -12px rgba(15, 23, 42, 0.18);
  overflow: hidden;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

/* coloured accent along the top edge */
.csum-card::before {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 4px;
  background: linear-gradient(90deg, var(--csum-accent), color-mix(in srgb, var(--csum-accent) 55%, #ffffff));
}

.csum-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.05), 0 14px 28px -14px rgba(15, 23, 42, 0.28);
}

.csum-title {
  margin: 0 0 10px;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: var(--cui-text, #131a2c);
}

/* all numbers of a card stay on one line (phones with 4+ numbers switch to 2 × 2 below) */
.csum-metrics {
  display: flex;
  flex-wrap: nowrap;
  margin: 0;
}

.csum-metric {
  box-sizing: border-box; /* padding + divider stay inside the width (2 × 50% fits on phones) */
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column-reverse; /* <dt> comes first in the markup but shows under the <dd> value */
  align-items: center;
  /* values on top, all on one line even when a label wraps to two lines (column-reverse: flex-end = top) */
  justify-content: flex-end;
  gap: 4px;
  padding: 4px 6px;
  text-align: center;
}

/* thin divider between numbers */
.csum-metric + .csum-metric {
  border-left: 1px solid var(--cui-border-soft, #e6e9f0);
}

.csum-value {
  margin: 0;
  /* shrinks a little on narrow screens so long numbers like 12,34,567 still fit */
  font-size: clamp(20px, 1rem + 0.7vw, 26px);
  line-height: 1.1;
  font-weight: 800;
  color: var(--cui-text, #131a2c);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  /* last resort for a very long number: cut with "…" (the full value is in the hover title) */
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.csum-label {
  font-size: 13px;
  font-weight: 500;
  color: #667085;
  line-height: 1.25;
}

.csum-skeleton {
  display: inline-block;
  width: 56px;
  height: 26px;
  border-radius: 8px;
  background: linear-gradient(90deg, #eef0f5 0%, #f7f8fb 50%, #eef0f5 100%);
  background-size: 200% 100%;
  animation: csum-shimmer 1.2s ease-in-out infinite;
}

@keyframes csum-shimmer {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}

/* tones: accent bar colour + soft tint behind the title */
.csum-primary { --csum-accent: #7c8cf8; --csum-tint: #f1f3ff; }
.csum-pink    { --csum-accent: #f06bb0; --csum-tint: #fff1f8; }
.csum-warning { --csum-accent: #f2c94c; --csum-tint: #fffaea; }
.csum-success { --csum-accent: #5ccf73; --csum-tint: #effcf2; }
.csum-info    { --csum-accent: #38bdf8; --csum-tint: #eff9ff; }
.csum-purple  { --csum-accent: #a78bfa; --csum-tint: #f6f2ff; }
.csum-danger  { --csum-accent: #f87171; --csum-tint: #fff3f3; }
.csum-neutral { --csum-accent: #94a3b8; --csum-tint: #f5f7fa; }

/* phones: one card per line, full width; tighter numbers */
@media (max-width: 575.98px) {
  .csum-row { gap: 10px; }
  .csum-row > .csum-card { flex-basis: 100% !important; max-width: 100%; min-width: 0; }
  .csum-card { padding: 14px 6px 12px; border-radius: 14px; }
  .csum-title { font-size: 14px; margin-bottom: 8px; }
  .csum-metric { padding: 4px 6px; }
  .csum-label { font-size: 12px; }

  /* 4+ numbers don't fit side by side on a phone → 2 × 2 grid with dividers between the cells */
  .csum-metrics:has(> .csum-metric:nth-child(4)) { flex-wrap: wrap; }
  .csum-metrics:has(> .csum-metric:nth-child(4)) > .csum-metric { flex: 1 1 50%; }
  .csum-metrics:has(> .csum-metric:nth-child(4)) > .csum-metric:nth-child(odd) { border-left: none; }
  .csum-metrics:has(> .csum-metric:nth-child(4)) > .csum-metric:nth-child(n + 3) {
    border-top: 1px solid var(--cui-border-soft, #e6e9f0);
    margin-top: 6px;
    padding-top: 10px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .csum-card,
  .csum-skeleton { transition: none; animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomSummaryCard/CustomSummaryCard.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;;;EAGE;AACF;EACE,yEAAyE;AAC3E;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,kBAAkB;EAClB,sBAAsB,EAAE,mEAAmE;EAC3F,yFAAyF;EACzF,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iDAAiD;EACjD,qEAAqE;EACrE,qFAAqF;EACrF,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,2GAA2G;AAC7G;;AAEA;EACE,2BAA2B;EAC3B,sFAAsF;AACxF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA,0FAA0F;AAC1F;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,sBAAsB,EAAE,qEAAqE;EAC7F,SAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B,EAAE,kEAAkE;EAClG,mBAAmB;EACnB,yGAAyG;EACzG,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,sDAAsD;AACxD;;AAEA;EACE,SAAS;EACT,gFAAgF;EAChF,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;EACnB,4FAA4F;EAC5F,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,4BAA4B,EAAE;AACrC;;AAEA,0DAA0D;AAC1D,gBAAgB,sBAAsB,EAAE,oBAAoB,EAAE;AAC9D,gBAAgB,sBAAsB,EAAE,oBAAoB,EAAE;AAC9D,gBAAgB,sBAAsB,EAAE,oBAAoB,EAAE;AAC9D,gBAAgB,sBAAsB,EAAE,oBAAoB,EAAE;AAC9D,gBAAgB,sBAAsB,EAAE,oBAAoB,EAAE;AAC9D,gBAAgB,sBAAsB,EAAE,oBAAoB,EAAE;AAC9D,gBAAgB,sBAAsB,EAAE,oBAAoB,EAAE;AAC9D,gBAAgB,sBAAsB,EAAE,oBAAoB,EAAE;;AAE9D,2DAA2D;AAC3D;EACE,YAAY,SAAS,EAAE;EACvB,yBAAyB,2BAA2B,EAAE,eAAe,EAAE,YAAY,EAAE;EACrF,aAAa,sBAAsB,EAAE,mBAAmB,EAAE;EAC1D,cAAc,eAAe,EAAE,kBAAkB,EAAE;EACnD,eAAe,gBAAgB,EAAE;EACjC,cAAc,eAAe,EAAE;;EAE/B,8FAA8F;EAC9F,iDAAiD,eAAe,EAAE;EAClE,gEAAgE,aAAa,EAAE;EAC/E,+EAA+E,iBAAiB,EAAE;EAClG;IACE,qDAAqD;IACrD,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;mBACiB,gBAAgB,EAAE,eAAe,EAAE;AACtD","sourcesContent":["/* CustomSummaryCard — grouped KPI card (title + numbers split by dividers) */\n\n.csum-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n}\n\n/*\n * A card alone on its line (e.g. \"Messages\" after the row wraps) must not stretch across the page:\n * at most half the row, like col-6 — unless its numbers need more room (--csum-cols × ~110px).\n */\n.csum-row > .csum-card {\n  max-width: max(calc(50% - 7px), calc(var(--csum-cols, 2) * 110px + 22px));\n}\n\n.csum-card {\n  --csum-accent: var(--cui-primary);\n  --csum-tint: var(--cui-primary-soft);\n  position: relative;\n  box-sizing: border-box; /* padding counts inside the flex width, so rows don't wrap early */\n  /* never squeezed below ~84px per number: the whole card wraps to the next line instead */\n  min-width: calc(var(--csum-cols, 2) * 84px + 22px);\n  display: flex;\n  flex-direction: column;\n  padding: 16px 10px 14px;\n  border-radius: 16px;\n  border: 1px solid var(--cui-border-soft, #e6e9f0);\n  background: linear-gradient(180deg, var(--csum-tint) 0%, #ffffff 58%);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 20px -12px rgba(15, 23, 42, 0.18);\n  overflow: hidden;\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n/* coloured accent along the top edge */\n.csum-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 0 auto 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--csum-accent), color-mix(in srgb, var(--csum-accent) 55%, #ffffff));\n}\n\n.csum-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.05), 0 14px 28px -14px rgba(15, 23, 42, 0.28);\n}\n\n.csum-title {\n  margin: 0 0 10px;\n  text-align: center;\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  color: var(--cui-text, #131a2c);\n}\n\n/* all numbers of a card stay on one line (phones with 4+ numbers switch to 2 × 2 below) */\n.csum-metrics {\n  display: flex;\n  flex-wrap: nowrap;\n  margin: 0;\n}\n\n.csum-metric {\n  box-sizing: border-box; /* padding + divider stay inside the width (2 × 50% fits on phones) */\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column-reverse; /* <dt> comes first in the markup but shows under the <dd> value */\n  align-items: center;\n  /* values on top, all on one line even when a label wraps to two lines (column-reverse: flex-end = top) */\n  justify-content: flex-end;\n  gap: 4px;\n  padding: 4px 6px;\n  text-align: center;\n}\n\n/* thin divider between numbers */\n.csum-metric + .csum-metric {\n  border-left: 1px solid var(--cui-border-soft, #e6e9f0);\n}\n\n.csum-value {\n  margin: 0;\n  /* shrinks a little on narrow screens so long numbers like 12,34,567 still fit */\n  font-size: clamp(20px, 1rem + 0.7vw, 26px);\n  line-height: 1.1;\n  font-weight: 800;\n  color: var(--cui-text, #131a2c);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n  /* last resort for a very long number: cut with \"…\" (the full value is in the hover title) */\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.csum-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #667085;\n  line-height: 1.25;\n}\n\n.csum-skeleton {\n  display: inline-block;\n  width: 56px;\n  height: 26px;\n  border-radius: 8px;\n  background: linear-gradient(90deg, #eef0f5 0%, #f7f8fb 50%, #eef0f5 100%);\n  background-size: 200% 100%;\n  animation: csum-shimmer 1.2s ease-in-out infinite;\n}\n\n@keyframes csum-shimmer {\n  from { background-position: 200% 0; }\n  to { background-position: -200% 0; }\n}\n\n/* tones: accent bar colour + soft tint behind the title */\n.csum-primary { --csum-accent: #7c8cf8; --csum-tint: #f1f3ff; }\n.csum-pink    { --csum-accent: #f06bb0; --csum-tint: #fff1f8; }\n.csum-warning { --csum-accent: #f2c94c; --csum-tint: #fffaea; }\n.csum-success { --csum-accent: #5ccf73; --csum-tint: #effcf2; }\n.csum-info    { --csum-accent: #38bdf8; --csum-tint: #eff9ff; }\n.csum-purple  { --csum-accent: #a78bfa; --csum-tint: #f6f2ff; }\n.csum-danger  { --csum-accent: #f87171; --csum-tint: #fff3f3; }\n.csum-neutral { --csum-accent: #94a3b8; --csum-tint: #f5f7fa; }\n\n/* phones: one card per line, full width; tighter numbers */\n@media (max-width: 575.98px) {\n  .csum-row { gap: 10px; }\n  .csum-row > .csum-card { flex-basis: 100% !important; max-width: 100%; min-width: 0; }\n  .csum-card { padding: 14px 6px 12px; border-radius: 14px; }\n  .csum-title { font-size: 14px; margin-bottom: 8px; }\n  .csum-metric { padding: 4px 6px; }\n  .csum-label { font-size: 12px; }\n\n  /* 4+ numbers don't fit side by side on a phone → 2 × 2 grid with dividers between the cells */\n  .csum-metrics:has(> .csum-metric:nth-child(4)) { flex-wrap: wrap; }\n  .csum-metrics:has(> .csum-metric:nth-child(4)) > .csum-metric { flex: 1 1 50%; }\n  .csum-metrics:has(> .csum-metric:nth-child(4)) > .csum-metric:nth-child(odd) { border-left: none; }\n  .csum-metrics:has(> .csum-metric:nth-child(4)) > .csum-metric:nth-child(n + 3) {\n    border-top: 1px solid var(--cui-border-soft, #e6e9f0);\n    margin-top: 6px;\n    padding-top: 10px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .csum-card,\n  .csum-skeleton { transition: none; animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
